import * as R from 'ramda'
import * as recompose from 'recompose'
import { connect } from 'react-redux'

import * as session from '@rushplay/session'

import * as configuration from '../configuration'

import { RealityCheck as Component } from './reality-check'

export const RealityCheck = R.compose(
  connect(state => ({
    gameServerUrl: configuration.getGameServerUrl(state.configuration),
    authenticated: session.getSessionToken(state.session),
  })),
  recompose.branch(
    props => R.isNil(props.authenticated),
    recompose.renderNothing
  )
)(Component)
